interface RedirectUri {
  redirectUri: string;
}

import { API_BASE } from '@/constants/api';

export const HOME: string = '/home';
export const ZENDESK_NEW_TICKET_PART = `/hc/en-us/requests/new`;
export const ZENDESK_DEV = 'https://sensefly1568122755.zendesk.com';
export const ZENDESK_PROD = 'https://sensefly.zendesk.com';
export const redirectUri = (): RedirectUri => ({ redirectUri: window.location.origin + HOME });

export const ZENDESK_AUTH = (token: any) => {
  const zendeskUrl = process.env.VUE_APP_ENV === 'production' ? ZENDESK_PROD : ZENDESK_DEV;
  return `${API_BASE}/jwt/zendesk?access_token=${token}&return_to=${encodeURI(zendeskUrl)}`;
};

export const getZendeskAuthURL = (token: any) => ZENDESK_AUTH(token);

function keycloakRootUrl() {
  switch (process.env.VUE_APP_ENV) {
    case 'production' :
      return 'https://account.sensefly.com';
    case 'staging' :
      return 'https://account-staging.sensefly.com';
    case 'test' :
      return 'https://account-test.sensefly.com';
    default:
      throw new Error(`Unsupported VUE_APP_ENV: ${process.env.VUE_APP_ENV}`);
  }
}

export const KEYCLOAK_ROOT_URL = keycloakRootUrl();
export const KEYCLOAK_CHANGE_PASS_URL = `${KEYCLOAK_ROOT_URL}/auth/realms/sensefly/account/password`;
export const KEYCLOAK_LOGOUT_URL = `${KEYCLOAK_ROOT_URL}/auth/realms/sensefly/protocol/openid-connect/logout?redirect_uri=${window.location.origin}`; // tslint:disable
export const ZENDESK_LOGOUT_URL = `${API_BASE}/jwt/zendesk/logout`;



// WEBPACK FOOTER //
// ./src/constants/urls.ts